import { render, staticRenderFns } from "./AssistanceTypePieChart.vue?vue&type=template&id=5b11e8e4&"
import script from "./AssistanceTypePieChart.vue?vue&type=script&lang=js&"
export * from "./AssistanceTypePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports